/**
 *   Toggle button
 */

module.exports = function () {

    return function (app) {
        toggleButton()
    }
  
    function toggleButton() {
        /*jQuery('.togglenow').on('click', function (event) {
            event.preventDefault();
            jQuery('.section--toggle').slideDown();
            // Scroll down
            jQuery("html, body").animate({
                // scrollTop: jQuery(this).parent().parent().parent().parent().parent().parent().parent().parent().next().offset().top
                scrollTop: jQuery('.section--toggle').offset().top
            }, 800);
            return false;
        });*/

        var el = document.getElementById('trigger');
        el.addEventListener("click", function () {
          console.log('clicked')
          var nav = this.parentElement.parentElement,
            _class = "is-active",
            _content = "open";
    
          el.classList.contains(_class)
            ? el.classList.remove(_class)
            : el.classList.add(_class);
          
            nav.classList.contains(_content)
            ? nav.classList.remove(_content)
            : nav.classList.add(_content);
        });
    }
}
  